import React from 'react';

interface StreamingIndicatorProps {
  statusMessage: string;
  isStreaming: boolean;
}

const StreamingIndicator: React.FC<StreamingIndicatorProps> = ({ statusMessage, isStreaming }) => {
  return (
    <div className="flex gap-2.5 mb-3">
      <div className="w-7 h-7 bg-slate-800 rounded-lg flex items-center justify-center shrink-0 mt-0.5">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5 text-white animate-pulse" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      </div>
      <div className="bg-slate-50 px-3.5 py-2.5 rounded-2xl rounded-tl-md">
        <div className="flex items-center gap-2">
          <div className="flex gap-1">
            <div className="w-1.5 h-1.5 rounded-full bg-slate-400 animate-bounce" />
            <div className="w-1.5 h-1.5 rounded-full bg-slate-400 animate-bounce" style={{ animationDelay: '0.1s' }} />
            <div className="w-1.5 h-1.5 rounded-full bg-slate-400 animate-bounce" style={{ animationDelay: '0.2s' }} />
          </div>
          <span className="text-[10px] text-slate-400">
            {statusMessage || (isStreaming ? 'Typing...' : 'Thinking...')}
          </span>
        </div>
      </div>
    </div>
  );
};

export default React.memo(StreamingIndicator);
